import { registerSystem } from "yage/components/ComponentRegistry";
import { System } from "yage/components/System";
import { PlayerTypeSchema, EnemyTypeSchema } from "yage/components/entity/Types";
import { ComponentCategory } from "yage/constants/enums";
import { Component, Schema, defaultValue, type } from "yage/decorators/type";
import { GameModel } from "yage/game/GameModel";
import { ChildSchema } from "yage/schemas/entity/Child";
import { getPlayerCharacter } from "../../utils/playerCharacter";

@Component("ShareOnPickup")
export class ShareOnPickupSchema extends Schema {
  @type(["number"])
  @defaultValue([])
  entities: number[];

  @type("number")
  @defaultValue(-1)
  owner: number;

  @type("number")
  @defaultValue(0)
  pickedup: number;
}

class ShareOnPickupSystem implements System {
  schema = ShareOnPickupSchema;
  type = "ShareOnPickup";
  dependencies = ["Child"];

  init(entity: number, gameModel: GameModel) {
    if (
      !gameModel.hasComponent(entity, PlayerTypeSchema) &&
      !gameModel.hasComponent(entity, EnemyTypeSchema) &&
      gameModel.hasComponent(entity, ChildSchema)
    ) {
      let parent = gameModel.getTypedUnsafe(entity, ChildSchema).parent!;
      if (gameModel.hasComponent(parent, "PlayerInput")) {
        parent = getPlayerCharacter(parent, gameModel);
      }
      gameModel.addIfMissing(parent, ShareOnPickupSchema);
      const parentData = gameModel.getTypedUnsafe(parent, ShareOnPickupSchema);
      parentData.entities.push(entity);
    }
  }
}

registerSystem(ShareOnPickupSystem);
